import { BindersIcon } from '../../../assets/icons';
import { Container, Flex } from '../../Layout';
import { Text } from '../../Text';

export type EmployerDetailsProps = {
  organizationName: string;
  organizationNumber: string;
  partnerNumber: string;
  agreementNumber: string;
  detailRows: 3 | 2 | 1;
};

export const EmployerDetails = ({
  organizationName,
  organizationNumber,
  partnerNumber,
  agreementNumber,
  detailRows = 1,
}: EmployerDetailsProps) => {
  return (
    <Container paddingBottom={10} paddingTop={10} marginLeft={detailRows < 3 ? undefined : 'auto'}>
      <Flex justifyContent={detailRows < 3 ? 'center' : 'flex-end'}>
        <BindersIcon color="white" width={14} marginRight={7} />
        <Text size="standard" fontWeight="semibold" color="white" style={{ fontSize: '16px' }}>
          {organizationName}
        </Text>
      </Flex>
      {detailRows === 3 && (
        <>
          <Text color="babyBlue" style={xSmallTextStyle} textAlign="right">
            Organisationsnummer: {organizationNumber}
          </Text>
          <Text color="babyBlue" style={xSmallTextStyle} textAlign="right">
            Kundnummer: {partnerNumber}
          </Text>
          <Text color="babyBlue" style={xSmallTextStyle} textAlign="right">
            Avtalsnummer: {agreementNumber}
          </Text>
        </>
      )}
      {detailRows === 2 && (
        <>
          <Text color="babyBlue" textAlign="center" style={xSmallTextStyle} marginBottom={6}>
            Organisationsnummer: {organizationNumber}
          </Text>
          <Flex columnGap={10}>
            <Text color="babyBlue" style={xSmallTextStyle}>
              Kundnummer: {partnerNumber}
            </Text>
            <Text color="babyBlue" style={xSmallTextStyle}>
              |
            </Text>
            <Text color="babyBlue" style={xSmallTextStyle}>
              Avtalsnummer: {agreementNumber}
            </Text>
          </Flex>
        </>
      )}
      {detailRows === 1 && (
        <Flex columnGap={10}>
          <Text color="babyBlue" style={xSmallTextStyle}>
            Organisationsnummer: {organizationNumber}
          </Text>
          <Text color="babyBlue" style={xSmallTextStyle}>
            |
          </Text>
          <Text color="babyBlue" style={xSmallTextStyle}>
            Kundnummer: {partnerNumber}
          </Text>
          <Text color="babyBlue" style={xSmallTextStyle}>
            |
          </Text>
          <Text color="babyBlue" style={xSmallTextStyle}>
            Avtalsnummer: {agreementNumber}
          </Text>
        </Flex>
      )}
    </Container>
  );
};

// Task 117704: FE: Add way to turn off responsive fonts
const xSmallTextStyle = {
  fontSize: '12px',
};
